var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "仪表名称", prop: "shareMeterName" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.shareMeterName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "shareMeterName", $$v)
                          },
                          expression: "childData.shareMeterName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "小区名称", prop: "areaId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          staticStyle: { width: "330px" },
                          attrs: {
                            filterable: "",
                            placeholder: "请选择小区名称"
                          },
                          on: { change: _vm.areaChange },
                          model: {
                            value: _vm.childData.areaId,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "areaId", $$v)
                            },
                            expression: "childData.areaId"
                          }
                        },
                        _vm._l(_vm.areaList, function(item) {
                          return _c("el-option", {
                            key: item.areaId,
                            attrs: {
                              label: item.areaName,
                              value: parseInt(item.areaId)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "分摊方式", prop: "shareMode" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          staticStyle: { width: "330px" },
                          attrs: {
                            filterable: "",
                            placeholder: "请选择分摊方式"
                          },
                          model: {
                            value: _vm.childData.shareMode,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "shareMode", $$v)
                            },
                            expression: "childData.shareMode"
                          }
                        },
                        _vm._l(_vm.shareModeList, function(item) {
                          return _c("el-option", {
                            key: item.dicValue,
                            attrs: {
                              label: item.dicName,
                              value: parseInt(item.dicValue)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "公摊仪表类型", prop: "shareType" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 0, disabled: _vm.keyValue > 0 },
                          model: {
                            value: _vm.childData.shareType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "shareType", $$v)
                            },
                            expression: "childData.shareType"
                          }
                        },
                        [_vm._v("公摊表")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1, disabled: _vm.keyValue > 0 },
                          model: {
                            value: _vm.childData.shareType,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "shareType", $$v)
                            },
                            expression: "childData.shareType"
                          }
                        },
                        [_vm._v("总表")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "仪表类型", prop: "meterId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form-item-width",
                          staticStyle: { width: "330px" },
                          attrs: {
                            filterable: "",
                            placeholder: "请选择仪表类型"
                          },
                          model: {
                            value: _vm.childData.meterId,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "meterId", $$v)
                            },
                            expression: "childData.meterId"
                          }
                        },
                        _vm._l(_vm.meterTypeList, function(item) {
                          return _c("el-option", {
                            key: item.meterId,
                            attrs: {
                              label: item.meterName,
                              value: parseInt(item.meterId)
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "倍率", prop: "meterPower" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.meterPower,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "meterPower", $$v)
                          },
                          expression: "childData.meterPower"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "损耗率", prop: "meterWastageRate" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.meterWastageRate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "meterWastageRate", $$v)
                          },
                          expression: "childData.meterWastageRate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "初始读数", prop: "currentRead" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.currentRead,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "currentRead", $$v)
                          },
                          expression: "childData.currentRead"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "读数日期", prop: "readDate" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "330px" },
                        attrs: {
                          disabled: _vm.keyValue > 0,
                          type: "date",
                          placeholder: "请选择读数日期",
                          format: "yyyy-MM-dd",
                          "value-format": "yyyy-MM-dd"
                        },
                        model: {
                          value: _vm.childData.readDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "readDate", $$v)
                          },
                          expression: "childData.readDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注", prop: "meterRemark" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        model: {
                          value: _vm.childData.meterRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "meterRemark", $$v)
                          },
                          expression: "childData.meterRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("el-row"),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _vm.childData.shareType === 1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "分摊房间" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled:
                                  !_vm.childData.areaId > 0 ||
                                  !_vm.childData.meterId > 0,
                                type: "primary"
                              },
                              on: { click: _vm.handleShareMeter }
                            },
                            [_vm._v("添加分摊房间")]
                          ),
                          _c(
                            "el-button",
                            { on: { click: _vm.deleteShareMeter } },
                            [_vm._v("删除分摊房间")]
                          ),
                          _c(
                            "el-table",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-top": "10px"
                              },
                              attrs: {
                                height: 150,
                                data: _vm.shareList,
                                border: "",
                                stripe: "",
                                fit: "",
                                "highlight-current-row": ""
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection", width: "55" }
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "小区名称" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.areaName))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  698670774
                                )
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "楼栋" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.buildingName)
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3496157463
                                )
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "单元" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.unitName))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2151930279
                                )
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "房间代码" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.houseCode))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2954854127
                                )
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "房间面积（㎡）",
                                  "min-width": "120px"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(scope.row.houseArea))
                                          ])
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3382161237
                                )
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm.childData.shareType === 0
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "分摊的房间" } },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled:
                                  !_vm.childData.areaId > 0 ||
                                  !_vm.childData.meterId > 0,
                                type: "primary"
                              },
                              on: { click: _vm.hamdleShareHouse }
                            },
                            [_vm._v("添加分摊房间")]
                          ),
                          _c(
                            "el-button",
                            { on: { click: _vm.deleteShareHouse } },
                            [_vm._v("删除分摊房间")]
                          ),
                          _c(
                            "el-table",
                            {
                              staticStyle: {
                                width: "100%",
                                "margin-top": "10px"
                              },
                              attrs: {
                                height: 250,
                                data: _vm.houseList,
                                border: "",
                                stripe: "",
                                fit: "",
                                "highlight-current-row": ""
                              },
                              on: {
                                "selection-change": _vm.handleSelectionChange
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { type: "selection", width: "55" }
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "小区名称" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.areaName))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "楼栋" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.buildingName))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "单元" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.unitName))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { align: "center", label: "房间代码" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.houseCode))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  align: "center",
                                  label: "房间面积（㎡）",
                                  "min-width": "120px"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(_vm._s(scope.row.houseArea))
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "900px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("add-trees", {
            attrs: {
              keyModel: _vm.childData,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handTreeCancle }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }